<template>
  <base-section
  id="key-dates"
  >
    <v-container>
    <base-section-heading
    title="Key Dates"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
Submission Deadline (Title and Abstract): <span style="color: #6663A6"><strong>November 6th, 2026</strong></span><br />
Submission Deadline (Full Paper): <span style="color: #6663A6"><strong>November 13th, 2026</strong></span><br />
Notification of Acceptance: <span style="color: #6663A6"><strong>January 11th, 2027</strong></span><br />
Camera Ready: <span style="color: #6663A6"><strong>January 25th, 2027</strong></span><br />
</strong>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'KeyDates',

    data: () => ({

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
